module.exports = require("codemirror/addon/lint/lint");